import { useMutation } from '@tanstack/react-query';

import { DispatchEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useDeleteDispatchEventDraft() {
  return useMutation({
    mutationKey: [queryKeys.DispatchEvent.Delete],
    mutationFn: (id: number) => dispatchEventClient.delete(id),
  });
}

export default useDeleteDispatchEventDraft;
